var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS } from "../types/apiPaths";
export var fetchEnvironmentVariables = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.ADMIN_ENVIRONMENT_VARIABLES_AGENCY, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_1 = _a.sent();
                console.error("Error fetching environment variables:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchSyncStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.ADMIN_SYNC_STATUS, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_2 = _a.sent();
                console.error("Error fetching sync status:", error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
var triggerSync = function (kyInstance, path) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(path, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_3 = _a.sent();
                console.error("Error triggering sync ".concat(path, ":"), error_3);
                throw error_3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var syncTitlesToLegalDeposits = function (kyInstance) {
    return triggerSync(kyInstance, API_PATHS.ADMIN_SYNC_TITLES_TO_LEGAL_DEPOSITS);
};
export var syncOnixToLegalDeposits = function (kyInstance) {
    return triggerSync(kyInstance, API_PATHS.ADMIN_SYNC_ONIX_TO_LEGAL_DEPOSITS);
};
export var syncCollectionsToLegalDeposits = function (kyInstance) {
    return triggerSync(kyInstance, API_PATHS.ADMIN_SYNC_COLLECTIONS_TO_LEGAL_DEPOSITS);
};
export var syncPersonsToLegalDeposits = function (kyInstance) {
    return triggerSync(kyInstance, API_PATHS.ADMIN_SYNC_PERSONS_TO_LEGAL_DEPOSITS);
};
export var syncProductsToLegalDeposits = function (kyInstance) {
    return triggerSync(kyInstance, API_PATHS.ADMIN_SYNC_PRODUCTS_TO_LEGAL_DEPOSITS);
};
export var fetchSolrStats = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get("admin/solr/stats", {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_4 = _a.sent();
                console.error("Error fetching Solr stats:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Starts an asynchronous Solr reindex; answers at once (HTTP 202) with the run,
 * whose progress is then polled via {@link fetchSolrReindexRun}. HTTP 409 means
 * a reindex is already running.
 */
export var reindexSolr = function (kyInstance, core) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("admin/solr/reindex", {
                    headers: getHeaders(),
                    searchParams: { core: core },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
/** State of one reindex run (404 when unknown). */
export var fetchSolrReindexRun = function (kyInstance, runId, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("admin/solr/reindex/".concat(encodeURIComponent(runId)), { headers: getHeaders(), signal: signal })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
/** State of the most recent reindex run of the tenant, or null when none ran yet (404). */
export var fetchLatestSolrReindexRun = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("admin/solr/reindex/status", {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                error_5 = _b.sent();
                if (((_a = error_5.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    return [2 /*return*/, null];
                }
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchAuthorityUpdateStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get("admin/authority-update/status", {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_6 = _a.sent();
                console.error("Error fetching authority update status:", error_6);
                throw error_6;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateAuthorityUpdateSchedule = function (kyInstance, schedule) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.put("admin/authority-update/schedule", {
                        headers: getHeaders(),
                        json: schedule,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_7 = _a.sent();
                console.error("Error updating authority update schedule:", error_7);
                throw error_7;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var triggerAuthorityUpdateRun = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post("admin/authority-update/run", {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_8 = _a.sent();
                console.error("Error triggering authority update run:", error_8);
                throw error_8;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchIssnRegisterStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.ADMIN_ISSN_REGISTER_STATUS, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_9 = _a.sent();
                console.error("Error fetching ISSN register harvest status:", error_9);
                throw error_9;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateIssnRegisterSchedule = function (kyInstance, schedule) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.put(API_PATHS.ADMIN_ISSN_REGISTER_SCHEDULE, { headers: getHeaders(), json: schedule })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_10 = _a.sent();
                console.error("Error updating ISSN register harvest schedule:", error_10);
                throw error_10;
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Starts a harvest in the background (202); `full` ignores the harvest-from date. 409 = nothing started. */
export var triggerIssnRegisterRun = function (kyInstance, full) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.ADMIN_ISSN_REGISTER_RUN, __assign({ headers: getHeaders() }, (full ? { searchParams: { full: "true" } } : {})))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_11 = _a.sent();
                console.error("Error triggering ISSN register harvest:", error_11);
                throw error_11;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchAlephTitleSyncStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get("admin/aleph-title-sync/status", {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_12 = _a.sent();
                console.error("Error fetching Aleph title sync status:", error_12);
                throw error_12;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateAlephTitleSyncSchedule = function (kyInstance, schedule) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.put("admin/aleph-title-sync/schedule", {
                        headers: getHeaders(),
                        json: schedule,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_13 = _a.sent();
                console.error("Error updating Aleph title sync schedule:", error_13);
                throw error_13;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchObalkyKnihSyncStatus = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(API_PATHS.ADMIN_OBALKY_KNIH_SYNC_STATUS, { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_14 = _a.sent();
                console.error("Error fetching obalkyknih sync status:", error_14);
                throw error_14;
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Starts a forced (all titles) sync in the background; answers 202 with the status. */
export var startObalkyKnihSync = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.ADMIN_OBALKY_KNIH_SYNC, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_15 = _a.sent();
                console.error("Error starting obalkyknih sync:", error_15);
                throw error_15;
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Number of index-queue entries that failed 20 times and wait for a re-queue. */
export var fetchIndexQueueDeadCount = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("admin/solr/index-queue/dead", {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.dead];
        }
    });
}); };
/** Puts every dead entry of the search-index queue back in the queue; answers how many. */
export var requeueIndexQueueDeadEntries = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("admin/solr/index-queue/requeue", {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.requeued];
        }
    });
}); };
